import { format } from "date-fns";
import type { ItemActivityEvent } from "@forgepoint/shared";
import { ItemHistoryLine } from "./ItemHistoryLine";
import { visibleChanges } from "./itemHistoryLabels";
import type { ItemFieldTarget, ItemHistoryContext } from "./itemHistoryLabels";
import { buildHistorySentence } from "./itemHistoryRows";
import { useItemHistoryActor } from "./useItemHistoryActor";

interface ItemHistoryEntryProps {
  event: ItemActivityEvent;
  context: ItemHistoryContext;
  onSelectField: (target: ItemFieldTarget) => void;
}

/**
 * One recorded write as a History line.
 * @param event - The item event being rendered
 * @param context - The item and the names ids resolve through
 * @param onSelectField - Jumps the form to a clicked field
 */
export const ItemHistoryEntry = ({
  event,
  context,
  onSelectField,
}: ItemHistoryEntryProps) => {
  const actor = useItemHistoryActor()(event);
  const time = format(event.createdAt, "h:mm a");
  const sentence = buildHistorySentence(
    visibleChanges(event.eventMetadata.changes),
    context,
    { created: event.eventType === "ITEM_CREATED" },
  );

  return (
    <ItemHistoryLine
      actor={actor}
      sentence={sentence}
      time={time}
      reason={event.eventMetadata.reason ?? null}
      onSelectField={onSelectField}
      describeRemoval={(name) =>
        `${name} was removed by ${actor.name} at ${time}.`
      }
    />
  );
};
